import { CancelToken, CancelTokenSource } from 'axios';

export enum CANCEL_REQUEST_BY {
    BY_URL  = 'url',
    BY_LAST = 'last',
    ALL     = 'all',
}

export interface CancellationTokens {
    url: string;
    cancelToken?: CancelToken;
    source: CancelTokenSource;
}

export interface CancelRequest {
    url?: string;
    by: CANCEL_REQUEST_BY;
}
